<template>
  <div class="d-flex flex-transaction flex-nowrap">

    <b-button
        :disabled="!isSuccessfully() || !isReceiptExists()"
        :id="getTooltipTarget()"
        @click="download"
        variant="outline-primary"
        class="border-0 p-1"
        style="height: 34px; width: 34px"
    >
      <i class="fa fa-download"></i>
      <b-tooltip :target="getTooltipTarget()" triggers="hover">
        {{$t('transactions.receipt.download')}}
      </b-tooltip>
    </b-button>

    <b-button
        :disabled="!isSuccessfully()"
        :id="getTooltipTarget(isReceiptExists() ? 'regenerate' : 'generate')"
        @click="isReceiptExists() ? showGenerateModal = true : generate()"
        variant="outline-primary"
        class="border-0 p-1"
        style="height: 34px; width: 34px"
    >
      <i :class="{ 'fa fa-refresh': isReceiptExists(), 'fa fa-plus-square': !isReceiptExists() }"></i>
      <b-tooltip
          :target="getTooltipTarget(isReceiptExists() ? 'regenerate' : 'generate')"
          triggers="hover">
        <template v-if="isReceiptExists()">{{$t('transactions.receipt.regenerate')}}</template>
        <template v-else>{{$t('transactions.receipt.generate')}}</template>
      </b-tooltip>
    </b-button>
    <modal
        @ok="generate"
        @hide="showGenerateModal = false"
        :confirm="$t('transactions.receipt.regenerate')"
        :showModal="showGenerateModal">
      <template slot="body">
        <h3 class="text-center">{{$t('global.are_you_sure')}}</h3>
      </template>
    </modal>

    <b-button
        :disabled="!isSuccessfully() || !isReceiptExists()"
        :id="getTooltipTarget('send')"
        @click="showSendModal = true"
        variant="outline-primary"
        class="border-0 p-1"
        style="height: 34px; width: 34px"
    >
      <i class="fa fa-envelope"></i>
      <b-tooltip :target="getTooltipTarget('send')" triggers="hover">
        {{$t('transactions.receipt.send')}}
      </b-tooltip>
    </b-button>
    <modal
        @ok="send"
        @hide="showSendModal = false"
        :confirm="$t('transactions.receipt.send')"
        :showModal="showSendModal">
      <template slot="body">
        <h3 class="text-center">{{$t('global.are_you_sure')}}</h3>
      </template>
    </modal>

  </div>
</template>

<script>
import {get} from "lodash";

export default {
  name: 'ColumnReceiptActions',
  props: ['transaction'],
  data() {
    return {
      showGenerateModal: false,
      showSendModal: false
    }
  },
  methods: {
    download() {
      window.open(this.transaction.receipt.download_link, '_blank')
    },
    generate() {
      this.postData(`transactions/${this.transaction.id}/receipt/generate`).then((data) => {
        const receipt = get(data, 'data.item', null);
        if (receipt) {
          this.$set(this.transaction, 'receipt', receipt);
        }
      });
    },
    send() {
      this.postData(`transactions/${this.transaction.id}/receipt/send`);
    },
    isSuccessfully() {
      return ['succeeded', 'free', 'manual'].includes(this.transaction.status);
    },
    getTooltipTarget(type = 'download') {
      return `${type}-tooltip-target-${this.transaction.id}`;
    },
    isReceiptExists(){
      return !!get(this, 'transaction.receipt.download_link', null);
    }
  }
}
</script>
